import { Suspense, useMemo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader } from '../components';
import { PASSWORD_RESET_ROUTE, PORTAL_ROUTE } from '../constants/routes';
import useSearchParams from '../hooks/useSearchParams';
import { useAuth } from '../context/AuthContext';

export default function UnauthenticatedLayout() {
  const { isAuthenticated: authenticated, isLoading } = useAuth();
  const location = useLocation();
  const { new: isNew, token } = useSearchParams();

  const newUser = useMemo(() => {
    if (isNew) return isNew === 'True';

    return null;
  }, [isNew]);

  // The session lives in an HttpOnly cookie, so we cannot know whether the user is signed in
  // until the bootstrap refresh resolves. Redirecting before then would flash the login page at
  // every already-authenticated user.
  if (isLoading) {
    return <Loader />;
  }

  if (newUser !== undefined && newUser !== null && !authenticated) {
    return <Navigate to="/email-invitation" state={{ isNew: newUser, token }} />;
  }

  let { from } = location.state || {};
  const destination = (from && from.pathname) || `${PORTAL_ROUTE}/apps`;

  if (location.pathname === PASSWORD_RESET_ROUTE && location.key === 'default') {
    return (
      <Navigate
        to={{
          pathname: location.pathname,
          search: location.search,
        }}
      />
    );
  }

  const mfaSetupInProgress = localStorage.getItem('mfaSetupInProgress') === 'true';

  if (
    authenticated &&
    location.pathname !== PASSWORD_RESET_ROUTE &&
    !mfaSetupInProgress &&
    location.pathname !== '/setup-account'
  ) {
    return (
      <Navigate
        to={{
          pathname: destination,
          search: location.search,
        }}
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return (
    <Suspense fallback={<Loader />}>
      <Outlet />
    </Suspense>
  );
}
